import React from "react";
import { Head } from "../../components";
import CodeInput from "../../components/CodeInput/CodeInput";
import "./code.css";

const Code = () => {
  return (
    <>
      <div className="code-g">
        <Head title="Código" />
        <CodeInput />
      </div>
    </>
  );
};

export default Code;
